import React, { Component } from 'react';
import {
  ActivityIndicator,
  Dimensions,
  FlatList,
  Image,
  InteractionManager,
  Platform,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import { connect } from 'react-redux';
import _ from 'lodash';
import fileDownload from 'js-file-download';

import { FontAwesomeIcon, Modal } from '../modules';

import APIClient from '../utils/APIClient';
import Empty from '../common/Empty';
import Icon from '../common/Icon';
import OrderHeader from '../item/OrderHeader';
import OrderItem from '../item/OrderItem';
import AlertUtils from '../utils/AlertUtils';
import Utils from '../utils/Utils';
import UserManager from '../utils/UserManager';

const contentWidth = Math.min(Dimensions.get('window').width - 40, 300);

class ConfirmedOrderListScreen extends Component {

  static navigationOptions = ({navigation}) => {
    const {routes} = navigation.state;
    return {
      tabBarIcon: ({focused, tintColor}) => {
        return (
          <Icon
            type='FontAwesome'
            name='home'
            size={30}
            color={tintColor}/>
        );
      },
      tabBarVisible: !routes || routes.length <= 1,

      headerBackTitle: null,
      headerTitle: 'Đơn hàng đã chốt',
      headerLeft: null,
      headerRight: null,
    };
  };

  constructor (props) {
    super(props);

    this._loading = false;
    this._page = -1;
    const items = [];
    this.state = {
      query: this._query,
      refreshing: false,
      showingFilterList: false,
      items: items,
      noitem: false,
    };
  }

  componentDidMount () {
    InteractionManager.runAfterInteractions(() => {
      this._refreshData(false);
    });
  }

  componentWillUnmount () {
  }

  _refreshData = (refreshing) => {
    if (this._loading) {
      return;
    }

    this._resetData(refreshing);
    this._loadData();
  };

  _resetData = (refreshing) => {
    this._loading = false;
    this._page = 1;
    const items = [];
    this.setState({
      refreshing: refreshing,
      items: items,
      noitem: false,
    });
  };

  _loadData = async () => {
    if (this._loading || this._page <= 0) {
      return;
    }

    this._loading = true;
    const params = {
      page: this._page,
      limit: 30,
    };
    const path = `/orders/confirmed`;
    const {response, error} = await APIClient.GET(path, params);
    this._handleNetworkResponse(response, error);
    this._loading = false;
  };

  _handleNetworkResponse (response, error) {
    /*if (response) {
      console.log(response);
    }
    if (error) {
      console.error(error);
    }*/

    let {items, noitem} = this.state;
    if (response && response.response) {
      const newItems = response.response;
      if (newItems.length > 0) {
        items = items.concat(newItems);
        this._page++;
        this.setState({
          items: items,
        });
      } else {
        this._page = -1;
      }
      noitem = items.length === 0;
    } else {
      noitem = _.isEmpty(items);
    }

    this._loading = false;
    this.setState({
      refreshing: false,
      noitem: noitem,
    });
  }

  _keyExtractor = item => `${item.id}`;

  _onRefresh = () => this._refreshData(true);

  _onEndReached = () => this._loadData();

  _renderItem = ({item, index}) => {
    return (
      <OrderItem
        simple={!UserManager.getInstance().isAdmin()}
        data={item}
        onClick={this._handleClickItem}/>
    );
  };

  _handleClickItem = (item) => {
    if (Platform.OS === 'web') {
      const path = '/order/' + item.id;
      this.props.history.push(path);
    } else {
      const {navigation} = this.props;
      navigation.navigate('Order', {
        id: item.id,
      });
    }
  };

  _submit = async () => {
    const {items} = this.state;
    if (_.isEmpty(items)) {
      AlertUtils.alert({
        message: 'Không có đơn hàng đã chốt',
      });
      return;
    }

    const result
      = AlertUtils.confirm({
      message: 'Bạn có chắc muốn sinh mã kích hoạt cho các đơn hàng này?',
      actions: [
        {text: 'Bỏ qua', style: 'cancel'},
        {text: 'Sinh mã', onPress: this._doSubmit},
      ],
    });
    if (result) {
      this._doSubmit();
    }
  };

  _doSubmit = async () => {
    const {submitting} = this.state;
    if (submitting) {
      return;
    }

    this.setState({
      submitting: true,
    });
    const path = `/admin/ship`;
    const {items} = this.state;
    let ids = items.map(item => item.id);
    ids = _.join(ids, ',');
    const data = {
      ids: ids,
    };
    const {response, error} = await APIClient.POST(path, data);

    if (!_.isEmpty(response)) {
      this._refreshData(true);
      const filename = `KidsUP-${Utils.dateToString(new Date(),
        'YYYY-MM-DD')}.csv`;
      fileDownload('\ufeff' + response, filename);
    } else {
      const message
        = Utils.parseErrorMessage(response, error,
        'Sinh mã kích hoạt thất bại, vui lòng thử lại sau');
      AlertUtils.alert({message});
    }
    this.setState({
      submitting: false,
    });
  };

  _generateShippingFile = () => {

  };

  render () {
    const {refreshing, items, noitem, submitting} = this.state;
    return (
      <View
        style={styles.container}>
        <OrderHeader
          simple={!UserManager.getInstance().isAdmin()}/>
        <FlatList
          refreshing={refreshing}
          extraData={this.state}
          data={items}
          keyExtractor={this._keyExtractor}
          onRefresh={this._onRefresh}
          renderItem={this._renderItem}
          onEndReached={this._onEndReached}
          onEndReachedThreshold={0.5}
          style={styles.list}/>

        {noitem && <Empty
          text='Không có đơn hàng, bấm để thử lại'
          onClick={() => this._refreshData(false)}
          style={styles.empty}/>}

        <TouchableOpacity
          activeOpacity={0.75}
          onPress={this._submit}
          style={styles.submit}>
          <Image
            source={require('../img/btn.png')}
            style={styles.submitImage}/>
          <Text
            style={styles.submitText}>
            SINH MÃ KÍCH HOẠT
          </Text>
          {submitting && <View
            style={styles.submitting}>
            <ActivityIndicator
              animating
              color='#ffffff'
              style={styles.submittingIndicator}/>
          </View>}
        </TouchableOpacity>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f6efdb',
  },

  list: {
    flex: 1,
  },

  empty: {
    ...Platform.select({
      web: {
        top: 100,
      },
      ios: {
        top: 44,
      },
      android: {
        top: 44,
      },
    }),
  },

  submit: {
    width: contentWidth,
    height: 56,
    marginTop: 12,
    alignSelf: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'transparent',
  },
  submitImage: {
    position: 'absolute',
    top: 0, left: 0,
    width: contentWidth,
    height: 56,
    resizeMode: 'stretch',
  },
  submitText: {
    color: '#ffffff',
    fontSize: 20,
    fontWeight: 'bold',
    backgroundColor: 'transparent',
    zIndex: 1,
  },
  submitting: {
    position: 'absolute',
    top: 0, bottom: 0, right: 12,
    justifyContent: 'center',
    alignItems: 'center',
  },
  submittingIndicator: {},
});

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(
  ConfirmedOrderListScreen);



// WEBPACK FOOTER //
// ./src/order/ConfirmedOrderListScreen.js